export default "__VITE_ASSET__DbW_jLsh__"